module.exports = __webpack_public_path__ + "img/1990pigc.91a64cf4.png";